<div id="new-item" class="popup">
    <div id="input">
        <div id="new-item-title"></div>
        <input type="text" id="new-item-value">
    </div>
    <div class="buttons">
        <button class="select-button" on:click={useItem}>Use</button>
        <button class="select-button" on:click={close}>Close</button>
    </div>
</div>

<style>
    #new-item {
        display: none;
        top: 30vh;
        left: 30vw;
        height: 15vh;
        width: 30vw;
        position: absolute;
        z-index: 200;
        padding: 1vh;
    }

    #input {
        display: flex;
        gap: 0.5vw
    }
</style>

<script>
    import { elementDisplay } from "./utilities";
    import { state } from './data-store'

    function useItem() {
        let input_field = document.getElementById('new-item-value')
        if (input_field.value) {
            $state.new_item = input_field.value
        }
        close()
    }

    function close() {
            elementDisplay('new-item', 'none');
        }
</script>